<div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || global.globalAgencyId=='' ">
  <div class="row mt-4 ">
      <div class="col ">
          <div widget class="card border-0 box-shadow">
              <div class="card-body  widget-body pt-2">
                  <div class="text-center text-danger">
                      <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                          agency to view
                          details</label>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

<div *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">

    <div class="col-12">
        <h4 class="mb-2 font-header-1">Client</h4>
    </div>
    <div class="col-12 mt-3 p-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-body transparent">
                <div class="d-flex row mt-2 pl-3">
                    <!-- justify-content-center align-items-center -->
                     <div class="row">

                       <div class="col-lg-12">
                           <button type="button" class="btn blue-btn btn-sm ml-1 mb-1" (click)="AddClient('new')" *ngIf="fp.clientcreate">
                               Add Client
                           </button>&nbsp;
                       
                       <!-- Report -->
                        
                           <button type="button" (click)="report()" class="btn blue-btn btn-sm ml-1 mb-1" id="ClientListreport" *ngIf="fp?.report">
                               Report
                           </button>&nbsp;
   
                            <!-- Authorization Report -->
                
                         <button type="button" class="btn blue-btn btn-sm  mb-1 " (click)="isAuthorizationReport=true" id="ClientListisAuthorizationReport"
                         data-bs-target="#AuthReportinfo" data-bs-toggle="modal" *ngIf="fp?.authorizationreport">Authorization Report</button>
                         &nbsp;
                        
                       <!-- QP Info -->
                       
                           <button type="button" routerLink="/qp-info" class="btn blue-btn btn-sm ml-1 mb-1" id="ClientListqpinfo" *ngIf="fp?.employeeclientinfo">
                               Employee Client Info
                           </button>&nbsp;
                      
                       <!-- Eligibility -->
                       
                       <button class="btn blue-btn btn-sm ml-1 mb-1" type="button" data-bs-target="#EligibilityInfo" id="ClientListISEDI271Client"
                       data-bs-toggle="modal" (click)="ISEDI271Client= true;" *ngIf="fp?.eligibility">
                       Eligibility
                       </button>&nbsp;   
                       <button class="btn blue-btn btn-sm ml-1 mb-1" type="button"  id="Clientmakecallbtn" (click)="makeCall()"  [disabled]="!selectedClientIds.length" *ngIf="fp?.eventreminder" >
                       Event Reminder
                       </button>&nbsp;
                       <button class="btn btn-sm" style="float: right;" type="button" (click)="Refresh()">
                           <i class="fa fa-repeat">&nbsp;</i>Refresh</button>
                       <button class="btn btn-sm me-2" style="float: right;" type="button" (click)="exportmonitorlist()" [disabled]="selectedColor==null || selectedColor ==undefined || selectedColor==''">
                           Export Monitor List</button>
                           
                     </div>
                    
                     </div>
                    
                            
                  
        
                  
                </div>
                
              <div class="row mt-2">
             
                <div class="col-3">
                  <label style="font-weight:bold">Show Client</label>
                
                 

                  <ng-select class="w-70" [(ngModel)]="getClient.statusLId" (change)="getClientListDetails()"
                      style="color: black;" [clearable]="false" [searchable]="true" [items]="statusList"
                      bindLabel="lovName" bindValue="id">

                  </ng-select>
              </div>
            
                <div class="col-2">
                  <label style="font-weight:bold">Client/Medicaid</label>
                
                <input type="text" placeholder="Search Client/Medicaid" [(ngModel)]="getClient.searchText"
                    (keyup.enter)="getClientListDetails()"
                    [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'||global.globalAgencyId==null||global.globalAgencyId==''"
                    class="form-control h-auto">

                <i class="bi bi-search py-1 fs-5 iconSearch" id="button-addon2" (click)="getClientListDetails()"
                    style="margin-left:-20px;"></i>

            </div>
             
                  <!-- Monitor -->
                  
                  <div class="col-3">
                      <label style="font-weight:bold">Monitor</label>
                 
                      <ng-select [items]="monitorList" bindValue="label" [(ngModel)]="selectedColor"
                          placeholder="Select color" (ngModelChange)="monitorfilter()">
                          <ng-template ng-label-tmp let-item="item">
                              <i class="fa fa-circle" [ngStyle]="{'color': item.colorCode != null  ? item.colorCode  : (item.value != null ? item.value : '#f2f6f5') }"></i> {{ item.colorandnotes }}
                              <!-- <i class="fa fa-circle" [ngStyle]="{'color': item.value}"></i> {{ item.colorandnotes }} -->
                          </ng-template>

                          <ng-template ng-option-tmp let-item="item">
                              <i class="fa fa-circle" [ngStyle]="{'color': item.colorCode != null  ? item.colorCode  : (item.value != null ? item.value : '#f2f6f5') }"></i> {{ item.colorandnotes }}
                              <!-- <i class="fa fa-circle" [ngStyle]="{'color': item.value}"></i> {{ item.colorandnotes }} -->
                          </ng-template>
                      </ng-select>

                  </div>
                
                   <!-- Employee -->
                  
                      <div class="col-3">
                        <label style="font-weight:bold">Employee</label>
                  
                    <ng-select class="d-inline-flex w-100" [(ngModel)]="getClient.employeeID" (ngModelChange)="filterchange()"
                      id="ClientListQpEmployeeId" bindLabel="Value" bindValue="Key" [items]="EmployeeDropdown">
                    </ng-select>
                     </div>

                     <div class="col-3">
                      <label style="font-weight:bold">Authorization Status</label>
                
                  <ng-select class="d-inline-flex w-100" [(ngModel)]="getClient.authStatus" (ngModelChange)="filterchange()"
                    id="ClientListAuthStatus" bindLabel="Value" bindValue="Value" [items]="authDropdown">
                  </ng-select>
                   </div>
                   <div class="col-3">
                    <label style="font-weight:bold">Profile Status</label>
              
                <ng-select class="d-inline-flex w-100" [(ngModel)]="getClient.isCompleted" (ngModelChange)="filterchange()"
                  id="ClientProfileStatus" bindLabel="Key" bindValue="Value" [items]="profilestatus">
                </ng-select>
                 </div> 
                 <div class="col-3">
                  <label style="font-weight:bold">Language</label>

                  <ng-select class="d-inline-flex w-100" [(ngModel)]="getClient.languageLIds" [searchable]="true"
                    [clearable]="true" [multiple]="true" [items]="languageList" bindLabel="lovName"
                    bindValue="id" name="languageIds" (ngModelChange)="filterchange()"
                     >

                  </ng-select>

                 </div>   
                  </div>
                <!--================================== Client Ejs Grid================================================================-->
                <div class="row mt-2 pt-1">
                    <div class="col-12">
                       <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update ClientListTotalColumns constant in client.list.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'ClientListgrid' maps to localStorage key 'gridClientListgrid'
                                                                          -->
                        <ejs-grid #grid id='ClientListgrid' [dataSource]='data|async' [allowResizing]='true' [allowSorting]='true'
                        [allowReordering]="true"   [enablePersistence]="true"   allowPaging='true' [allowFiltering]='true' (dataStateChange)='dataChangeClient($event)'
                            (actionBegin)="onActionClient($event)" [pageSettings]='initialPage'
                            [filterSettings]='filterSettings' [showColumnChooser]='true' (queryCellInfo)='validatebutton($event)'
                            (rowSelected)="onRowSelected($event)" (rowDeselected)="onRowSelected($event)"  [selectionSettings]='selectionOptions'> 

                            <e-columns>
                              <e-column type='checkbox' [showInColumnChooser]='false' uid="checkbox" width=50 headerText='Select' 
                                textAlign='center' [allowEditing]='true' editType="booleanedit" [edit]='checkparams' >
                              </e-column>
                                <e-column width='150' uid="action" headerText="Actions" [showInColumnChooser]='false'>
                                    <ng-template #template let-data>


                                      <button class="btn btn-edit-table"
                                      (click)="Clientdatatobind(data);AddClient('edit');" *ngIf="fp.clientupdate">
                                      <i class="fa fa-edit"></i></button>&nbsp;
                                      <button class="btn btn-delete-table ms-3"  id="ClientListselectemployeedetails" *ngIf="fp.clientdelete"
                                      (click)="selectemployeedetails(data)"><i class="fa fa-trash"></i></button>&nbsp;
                                      <label class="dot mt-1" *ngIf="data.isMonitor"
                                          [ngStyle]="{ 'background-color': data.recentMonitorColorCode || data.recentMonitorColor }"
                                          (click)="viewClientMonitorList(data.id)"
                                          data-bs-target="#Viewemitmonitormodal1" data-bs-toggle="modal"></label>
                                      

                                    </ng-template>
                                </e-column>
                                <e-column minWidth=80 width="100" field="recentMonitorDate" headerText="Monitor Date"
                                    type='datetime' [format]='formatOptions'  [allowFiltering]="false">
                                </e-column>                
                                  <e-column minWidth="80" width="150" field="isCompleted" headerText="Profile Status" type="string"  [allowFiltering]="false">
                                    <ng-template #template let-data>
                                      <button 
                                      class="btn btn-sm" 
                                      [ngClass]="{'btn-success': data.isCompleted, 'btn-danger': !data.isCompleted}" 
                                      [style.background-color]="data.isCompleted ? 'green' : 'red'" 
                                      [style.color]="'white'" 
                                      (click)="openMissingDocumentsModal(data)">
                                      {{ data.isCompleted ? 'Completed' : 'Incomplete' }}
                                    </button>
                                    
                                    </ng-template>
                                  </e-column>                               
                                <e-column width=150 field="name" headerText="Name" type='string' [allowFiltering]='false'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                               <!-- QP Name -->
                                
                                <!-- <e-column minWidth=130 field="employeeNames" headerText="Employee Name" type='string'
                                [format]='formatOptions' > -->
                                <!-- <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template> -->
                                <!-- </e-column> -->
                                <e-column minWidth=130 width="150" field="employeeNames" headerText="Employee Name" type='string' [allowSorting]='false' [allowFiltering]="false">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>

                                <e-column minWidth=80 width="100" field="dob" headerText="DOB" type='datetime'
                                    [format]='formatOptions' [allowFiltering]="false">
                                </e-column>
                                <e-column width=80 field="age" headerText="Age" type='number' [allowFiltering]="false"></e-column>
                                <e-column minWidth=130  width="200" field="email" headerText="Email" type='string' [allowFiltering]="false">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100  width="80" field="locationName" type='string' headerText="Location" [allowFiltering]="false">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 width="150" field="phone1" headerText="Phone" type='string' [allowFiltering]='true'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>

                                <e-column minWidth=80 width="100" field="street" headerText="Street" type='string' [allowFiltering]="false">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=80 width="100" field="zipCode" headerText="ZIP Code" type='string' [allowFiltering]="false">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=80 width="100" field="county" headerText="County" type='string' [allowFiltering]="false">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>

                                <e-column minWidth=100 width="100" field="status_Name" headerText="Status" type='string' [allowFiltering]="false">
                                    <ng-template #filterTemplate let-data>

                                    </ng-template>
                                </e-column>
                                <e-column minWidth=80 width="100" field="authStatusName" headerText="Authorization Status" type='string' [allowFiltering]="false">
                                  <ng-template #filterTemplate let-data>
                                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                  </ng-template>
                              </e-column>
                                <!-- Medicaid -->
                  <e-column minWidth=100 width="80" field="medicaid" headerText="Medicaid" type='string'[allowFiltering]="false">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                                <!-- MA Eligible -->
                  <e-column minWidth=100 width="80" field="isMAEligible" headerText="MA Eligible" type='boolean' [allowFiltering]="false">
                    <ng-template #filterTemplate let-data>
                      <ejs-dropdownlist id='dropdown' placeholder='Select Eligibility' [dataSource]='eligiblitydropdata'
                        [popupHeight]='height'>
                      </ejs-dropdownlist>
                    </ng-template>
                  </e-column>
                  <!-- Plans End Date -->
                  <e-column minWidth=130 width="100" field="planEnd" headerText="Plans End Date" type='datetime'
                  [format]='formatOptions' [allowFiltering]="false">
                    <!-- <ng-template #filterTemplate let-data>
                      <ejs-dropdownlist id='dropdown' placeholder='Select Plans EndDate' [dataSource]='dropdatas'
                        [popupHeight]='height' [format]='formatOptions'></ejs-dropdownlist>
                    </ng-template> -->
                  </e-column>
                                
                                <!-- Last Eligibility -->
                                <e-column minWidth=120 width="100" field="lastEligibility" headerText="Last Eligibility" type='datetime'
                                  [format]='formatOptions' [allowFiltering]="false"></e-column>
                                  <!-- checkeligibility -->
<e-column width="50" minWidth=100 field="checkeligibility" id="checkeligibility"
headerText="Check Eligibility" textAlign="Center" [allowSorting]="false" [allowFiltering]="false">
<ng-template #template let-data>
    <button class="btn btn-edit-table" (click)="viewlasteb(data.id)" id="ClientListviewlasteb">
        <i class="fa fa-eye"></i>
    </button>&nbsp;
    <button class="btn btn-edit-table" data-bs-target="#EligibilitydiffInfo" id="ClientListvieweligibilitydiff"
        (click)="ISEDI271ClientDiffReport = true; vieweligibilitydiff(data.id)" data-bs-toggle="modal">
        <i class="fa fa-file"></i>
    </button>&nbsp;
</ng-template>
</e-column>

                                <!-- SpendDown -->
                  <e-column minWidth=100 width="100" field="spendDown" headerText="SpendDown" type='string' [allowFiltering]="false">
                    <ng-template #filterTemplate let-data>
                      <ejs-dropdownlist id='dropdown' placeholder='Select SpendDown' [dataSource]='spendown'
                        [popupHeight]='height'>
                      </ejs-dropdownlist>
                    </ng-template>
                  </e-column>
                                <e-column minWidth=80 width="100" field="cfssModel" headerText="CFSS model" type='string' [allowFiltering]="false">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 width="100" field="languages" headerText="Languages"
                                    type='string' [allowFiltering]="false"></e-column>

                                <e-column minWidth=100 width="100" field="isMNChoiceAssessment"
                                    headerText="MN Choice Assessment Received" type='string'>
                                    <ng-template #filterTemplate let-data>

                                    </ng-template>
                                </e-column>
                                <e-column width="50" [showInColumnChooser]='false'>
                                    <ng-template #headerTemplate let-data>
                                        <div>
                                            <span id='show' (click)='show()'><i class="fa fa-cog fa-lg"
                                                    aria-hidden="true">
                                                </i></span>
                                        </div>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                         <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update ClientListTotalColumns constant in client.list.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'ClientListgrid' maps to localStorage key 'gridClientListgrid'
                                                                          -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="modal fade " id="Reset_ConfirmationClient" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">

    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Reset Password</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                Do you want to reset your password?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal"
                    (click)="changeClientPortalPass()">Yes</button>
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>



<span id="openmonitorListModal" data-bs-target="#monitorListmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="monitorListmodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Monitor Notes</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-lg-5">
                                <label> Notes
                                </label>
                            </div>
                            <div class="col-lg-7">

                                <label> {{monitorNotes}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>


<!-- viewmonitormodal -->
<span id="Viewemitmonitormodal1" data-bs-target="#viewmonitormodal" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="viewmonitormodal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">View Monitor List</h5>
                <button type="button" class="btn-close" (click)="closeviewModal()"></button>
            </div>
            <div class="modal-body scroll">
                <app-client-monitorlist [ToMonitor]="this.EmitMonitorList"
                    *ngIf="EmitMonitorList.isClient && this.EmitMonitorList.clientId!=null"></app-client-monitorlist>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm ml-3" data-bs-dismiss="modal"
                    (click)="closeviewModal()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- EligibilityInfo -->
<span id="EligibilityOpen" data-bs-toggle="modal" data-bs-target="#EligibilityInfo"></span>
<div class="modal hide fade modalbackgrod supreme-container" id="EligibilityInfo" tabindex="-1"
  aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog mw-100" role="document">
    <div class="modal-content">
      <div class="modal-header modal-header1 border-0">
        <h5 class="modal-title text-left font-header">Eligibility Report</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeEligiblity()" id="ClientListcloseEligiblityicon"></button>
      </div>
      <div class="modal-body modal-body1">
        <app-eligibility-report *ngIf="ISEDI271Client">
        </app-eligibility-report>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" (click)="closeEligiblity()" id="ClientListcloseEligiblitybtn">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- EligibilitydiffInfo -->
<span id="EligibilitydiffOpen" data-bs-toggle="modal" data-bs-target="#EligibilitydiffInfo"></span>
<div class="modal hide fade modalbackgrod " id="EligibilitydiffInfo" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header ">
        <h5 class="modal-title text-left font-header">Eligibility Summary Difference Report</h5>
        <button type="button" class="btn-close" (click)="closeEligiblityDifference()" id="ClientListcloseEligiblityDifferenceicon"></button>
      </div>
      <div class="modal-body">
        <app-eligibility-difference-report [ClientId]="ClientId" *ngIf="ISEDI271ClientDiffReport">
        </app-eligibility-difference-report>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" (click)="closeEligiblityDifference()" id="ClientListcloseEligiblityDifferencebtn">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- printalert -->
<div class="modal fade" id="printalert" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Print confirmation</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" id="ClientListPrintconfirmation"></button>
      </div>
      <div class="modal-body">
        Do you want to print this record ?
      </div>
      <div class="modal-footer">

        <button class="btn blue-btn btn-sm butstyle " data-bs-dismiss="modal" (click)="print()" id="ClientListPrintconfirmationyes">Print
        </button>
        <button class="btn blue-btn btn-sm butstyle " data-bs-dismiss="modal" id="ClientListPrintconfirmationno">Cancel</button>
      </div>
    </div>
  </div>
</div>
<!-- view271C -->
<span id="openModal7" data-bs-target="#view271C" data-bs-toggle="modal"></span>
<div class="modal fade" id="view271C" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog1 modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header modal-header1 border-0">
        <h5 class="modal-title text-left font-header">271 Record</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="viewFiles271=false" id="ClientListviewFiles271icon"></button>
      </div>
      <div class="modal-body modal-body1">
        <div class="row">
          <div class="col-lg-12">
            <div style="width:730px ;padding-left:15px">
              <div>271 Report</div>
              <div *ngIf="viewFiles271">
                <ng-container *ngFor="let edi271 of edi271list">
                  <div class="row">
                    <div class="col-lg-3">FileName</div>
                    <div class="col-lg-9">: {{edi271.fileName}}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3">Imported Date</div>
                    <div class="col-lg-9">: {{edi271.importedDate|date:'MM/dd/yyyy'}}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3">Unique ISA Id</div>
                    <div class="col-lg-9">: {{edi271.unique271ISA}}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3">Interchange Date</div>
                    <div class="col-lg-9">: {{edi271.interchangeDateTime|date:'MM/dd/yyyy'}}</div>
                  </div>
                  <div class="Sender">
                    <h2>Sender</h2>
                    <div *ngIf="edi271.sender_EntityIdentifier!=null && edi271.sender_EntityIdentifier!=''" class="row">
                      <div class="col-lg-3">Entity</div>
                      <div class="col-lg-9">: {{edi271.sender_EntityIdentifier}}</div>
                    </div>
                    <div *ngIf="edi271.sender_Name!=null && edi271.sender_Name!=''" class="row">
                      <div class="col-lg-3">Name</div>
                      <div class="col-lg-9">: {{edi271.sender_Name}}</div>
                    </div>
                    <div *ngIf="edi271.sender_Id!= null && edi271.sender_Id!=''" class="row">
                      <div class="col-lg-3">ID</div>
                      <div class="col-lg-9">: {{edi271.sender_Id}} <br> ({{edi271.sender_IdQualifier}})</div>
                    </div>
                    <h6
                      *ngIf="edi271.sender_CommunicationNumberQualifier1!=null && edi271.sender_CommunicationNumberQualifier1!=''">
                      Contact</h6>
                    <div>{{edi271.sender_ContactName}}</div>
                    <div class="row"
                      *ngIf="edi271.sender_CommunicationNumber1!=null && edi271.sender_CommunicationNumber1!=''">
                      <div class="col-lg-3">{{edi271.sender_CommunicationNumberQualifier1}}</div>
                      <div class="col-lg-9">: {{edi271.sender_CommunicationNumber1}}</div>
                    </div>
                    <div *ngIf="edi271.sender_CommunicationNumber2!=null && edi271.sender_CommunicationNumber2!=''"
                      class="row">
                      <div class="col-lg-3">{{edi271.sender_CommunicationNumberQualifier2}}</div>
                      <div class="col-lg-9">: {{edi271.sender_CommunicationNumber2}}</div>
                    </div>
                    <div *ngIf="edi271.sender_CommunicationNumber3!=null && edi271.sender_CommunicationNumber3!=''"
                      class="row">
                      <div class="col-lg-3">{{edi271.sender_CommunicationNumberQualifier3}}</div>
                      <div class="col-lg-9">: {{edi271.sender_CommunicationNumber3}}</div>
                    </div>
                  </div>
                  <div class="Receiver">
                    <h2>Receiver</h2>
                    <div *ngIf="edi271.receiver_EntityIdentifier!=null && edi271.receiver_EntityIdentifier!=''"
                      class="row">
                      <div class="col-lg-3">Entity</div>
                      <div class="col-lg-9">: {{edi271.receiver_EntityIdentifier}}</div>
                    </div>
                    <div *ngIf="edi271.receiver_Name!=null && edi271.receiver_Name!=''" class="row">
                      <div class="col-lg-3">Name</div>
                      <div class="col-lg-9">: {{edi271.receiver_Name}}</div>
                    </div>
                    <div *ngIf="edi271.receiver_Id!=null && edi271.receiver_Id!=''" class="row">
                      <div class="col-lg-3">ID</div>
                      <div class="col-lg-9">: {{edi271.receiver_Id}} <br> ({{edi271.receiver_IdQualifier}})</div>
                    </div>
                    <div
                      *ngIf="edi271.receiver_AddressLine1 != null || edi271.receiver_AddressLine1!='' || edi271.receiver_City!=null || edi271.receiver_City !=''"
                      class="row">
                      <div class="col-lg-3">Address</div>
                      <div class="col-lg-9">: {{edi271.receiver_AddressLine1}} <br
                          *ngIf="edi271.receiver_AddressLine2 != null">
                        {{edi271.receiver_AddressLine2}} <br> {{edi271.receiver_City}} <br>
                        {{edi271.receiver_StateCode}}
                        <br> {{edi271.receiver_ZipCode}}
                      </div>
                    </div>
                  </div>
                  <ng-container *ngFor="let client of edi271?.clients">
                    <div class="Client">
                      <h3>Subscriber</h3>
                      <div class="ClientBasicDetails">
                        <div *ngIf="client.clientName!=null && client.clientName!=''" class="row">
                          <div class="col-lg-3">Name</div>
                          <div class="col-lg-9">: {{client.clientName}}</div>
                        </div>
                        <div *ngIf="client.clientID!=null && client.clientID!=''" class="row">
                          <div class="col-lg-3">ID</div>
                          <div class="col-lg-9">: {{client.clientID}} <br> ({{client.clientIdQualifier}})</div>
                        </div>
                        <div
                          *ngIf="edi271.receiver_AddressLine1 != null || edi271.receiver_AddressLine1!='' || edi271.receiver_City!=null || edi271.receiver_City !=''"
                          class="row">
                          <div class="col-lg-3">Address</div>
                          <div class="col-lg-9">: {{client.addressLine1}} <br *ngIf="client.addressLine2 != null">
                            {{client.addressLine2}} <br> {{client.city}} <br> {{client.state}} <br> {{client.zipCode}}
                          </div>
                        </div>
                        <div *ngIf="client.dOB!=null && client.dOB!=''" class="row">
                          <div class="col-lg-3">DOB</div>
                          <div class="col-lg-9">: {{client.dOB|date:'MM/dd/yyyy'}}</div>
                        </div>
                        <div *ngIf="client.gender!=null && client.gender!=''" class="row">
                          <div class="col-lg-3">Gender</div>
                          <div class="col-lg-9">: {{client.gender}}</div>
                        </div>
                      </div>
                      <div class="AAADetails" *ngIf="client.aaaDetails!=null && client.aaaDetails!=''">
                        <h5>Subscriber Validation</h5>
                        <ng-container *ngFor="let aaa of client?.aaaDetails">
                          <div *ngIf="aaa.validRequest!=null && aaa.validRequest!=''" class="row">
                            <div class="col-lg-3">Valid ReQuest</div>
                            <div class="col-lg-9">: {{aaa.validRequest}}</div>
                          </div>
                          <div *ngIf="aaa.agencyQualifier!=null && aaa.agencyQualifier!=''" class="row">
                            <div class="col-lg-3">Agency Qualifier</div>
                            <div class="col-lg-9">: {{aaa.agencyQualifier}}</div>
                          </div>
                          <div *ngIf="aaa.rejectReason!=null && aaa.rejectReason!=''" class="row">
                            <div class="col-lg-3">Reason For Rejection</div>
                            <div class="col-lg-9">: {{aaa.rejectReason}}</div>
                          </div>
                          <div *ngIf="aaa.followupAction!=null && aaa.followupAction!=''" class="row">
                            <div class="col-lg-3">Follow-Up Action</div>
                            <div class="col-lg-9">: {{aaa.followupAction}}</div>
                          </div>
                        </ng-container>
                      </div>
                      <div class="LoopDetails">
                        <ng-container *ngFor="let loop of client?.loopDetails">
                          <div class="EBandMessage">
                            <h5>Eligibility and Benefit Info</h5>
                            <div
                              *ngIf="loop.eligibilityorBenefitInformation!=null && loop.eligibilityorBenefitInformation!=''"
                              class="row">
                              <div class="col-lg-3">Eligibility or Beneefit Information</div>
                              <div class="col-lg-9">: {{loop.eligibilityorBenefitInformation}}</div>
                            </div>
                            <div *ngIf="loop.benefitCoverageLevel!=null && loop.benefitCoverageLevel!=''" class="row">
                              <div class="col-lg-3">Coverage Level</div>
                              <div class="col-lg-9">: {{loop.benefitCoverageLevel}}</div>
                            </div>
                            <div *ngIf="loop.serviceType!=null && loop.serviceType!=''" class="row">
                              <div class="col-lg-3">Service Covered</div>
                              <div class="col-lg-9">: {{loop.serviceType}}</div>
                            </div>
                            <div *ngIf="loop.insuranceType!=null && loop.insuranceType!=''" class="row">
                              <div class="col-lg-3">Insurance Type</div>
                              <div class="col-lg-9">: {{loop.insuranceType}}</div>
                            </div>
                            <div *ngIf="loop.planCoverageDescription!=null && loop.planCoverageDescription!=''"
                              class="row">
                              <div class="col-lg-3">Plan Coverage Description</div>
                              <div class="col-lg-9">: {{loop.planCoverageDescription}}</div>
                            </div>
                            <div *ngIf="loop.timePeriodQualifier!=null && loop.timePeriodQualifier!=''" class="row">
                              <div class="col-lg-3">Time Period</div>
                              <div class="col-lg-9">: {{loop.timePeriodQualifier}}</div>
                            </div>
                            <div *ngIf="loop.benefitAmount!=null && loop.benefitAmount!=''" class="row">
                              <div class="col-lg-3">Benefit Amount</div>
                              <div class="col-lg-9">: {{loop.benefitAmount}}</div>
                            </div>
                            <div *ngIf="loop.benefitPercent!=null && loop.benefitPercent!=''" class="row">
                              <div class="col-lg-3">Benefit Percentage</div>
                              <div class="col-lg-9">: {{loop.benefitPercent}}</div>
                            </div>
                            <div *ngIf="loop.quantityQualifier!=null && loop.quantityQualifier!=''" class="row">
                              <div class="col-lg-3">Quantity Qualifier</div>
                              <div class="col-lg-9">: {{loop.quantityQualifier}}</div>
                            </div>
                            <div *ngIf="loop.authorizationorCertificationIndicator!=null && loop.benefitQuantity!=''"
                              class="row">
                              <div class="col-lg-3">Benefit Quantity</div>
                              <div class="col-lg-9">: {{loop.benefitQuantity}}</div>
                            </div>
                            <div
                              *ngIf="loop.authorizationorCertificationIndicator!=null && loop.authorizationorCertificationIndicator!=''"
                              class="row">
                              <div class="col-lg-3">Authorization Certification</div>
                              <div class="col-lg-9">: {{loop.authorizationorCertificationIndicator}}</div>
                            </div>
                            <div *ngIf="loop.inPlanNetwork!=null && loop.inPlanNetwork!=''" class="row">
                              <div class="col-lg-3">InPlan Network</div>
                              <div class="col-lg-9">: {{loop.inPlanNetwork}}</div>
                            </div>
                            <div
                              *ngIf="loop.cmP_ProductorServiceIDQualifier!=null && loop.cmP_ProductorServiceIDQualifier!=''"
                              class="row">
                              <h6>Composite Medical Procedure</h6>
                              <div class="col-lg-3">Product or Service ID Qualifier</div>
                              <div class="col-lg-9">: {{loop.cmP_ProductorServiceIDQualifier}}</div>
                            </div>
                            <div *ngIf="loop.cmP_ProductServiceID!=null && loop.cmP_ProductServiceID!=''" class="row">
                              <div class="col-lg-3">Product Service ID</div>
                              <div class="col-lg-9">: {{loop.cmP_ProductServiceID}}</div>
                            </div>
                            <div *ngIf="loop.cmP_ProcedureCode!=null && loop.cmP_ProcedureCode!=''" class="row">
                              <div class="col-lg-3">Procedure Code</div>
                              <div class="col-lg-9">: {{loop.cmP_ProcedureCode}}</div>
                            </div>
                            <div *ngIf="loop.cmP_ProcedureModifiers!=null && loop.cmP_ProcedureModifiers!=''"
                              class="row">
                              <div class="col-lg-3">Procedure Modifiers</div>
                              <div class="col-lg-9">: {{loop.cmP_ProcedureModifiers}}</div>
                            </div>
                            <div *ngIf="loop.cmP_Description!=null && loop.cmP_Description!=''" class="row">
                              <div class="col-lg-3">Description</div>
                              <div class="col-lg-9">: {{loop.cmP_Description}}</div>
                            </div>
                            <div *ngIf="loop.diagnosisCodePointers!=null && loop.diagnosisCodePointers!=''" class="row">
                              <div class="col-lg-3">Diagnosis Code Pointer</div>
                              <div class="col-lg-9">: {{loop.diagnosisCodePointers}}</div>
                            </div>
                            <div *ngIf="loop.messages!=null && loop.messages!=''" class="row">
                              <div class="col-lg-3">Messages</div>
                              <div class="col-lg-9">: {{loop.messages}}</div>
                            </div>
                          </div>
                          <div class="DTPDetails">
                            <ng-container *ngFor="let dtp of loop?.dtpDetails">
                              <div *ngIf="dtp.dateTimeQualifier!=null && dtp.dateTimeQualifier!=''" class="row">
                                <div class="col-lg-3">{{dtp.dateTimeQualifier}}</div>
                                <div class="col-lg-9">: {{dtp.dateTimePeriod|date:'MM/dd/yyyy'}}</div>
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                  <br />
                  <hr />
                  <br />
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" id="ClientListviewFiles271cancel"
          (click)="viewFiles271=false">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- AuthReportinfo -->
<span id="AuthReportopen" data-bs-toggle="modal" data-bs-target="#AuthReportinfo"></span>
<div class="modal fade modalbackgrod" id="AuthReportinfo" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog mw-100">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Authorization Report</h5>
        <button type="button" class="btn-close"  aria-label="Close" id="ClientListisAuthorizationReporticon" (click)="closeauthreport()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <app-client-authorization-report *ngIf="isAuthorizationReport"></app-client-authorization-report>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" (click)="closeauthreport()" id="ClientListisAuthorizationReportbtn">Close</button>
      </div>
    </div>
  </div>
</div>

 <!-- Modal -->
 <span id="missingDocumentsModalTrigger" data-bs-target="#missingDocumentsModal" data-bs-toggle="modal"></span>
 <div class="modal fade" id="missingDocumentsModal" tabindex="-1" aria-labelledby="missingDocumentsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-m">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="missingDocumentsModalLabel">Check Validation Status</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-2">
          <input type="checkbox" class="me-2 mt-1" [(ngModel)]="isEnabled"
            (change)="SelectErrorData()" />
          <label class="label">Show errors only</label>
        </div>
        <table class="table table-bordered">
          <thead>
            <tr style="background-color:#00786a; color:white;border:1px solid lightgray;">
              <th>Field Name</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doc of documentDetails">
              <td>
                <span [ngClass]="{'text-success': doc.isValid, 'text-danger': !doc.isValid}">
                  {{ doc.columnName }}
                </span>
              </td>
              <td>
                <span [ngClass]="{'text-success': doc.isValid, 'text-danger': !doc.isValid}">
                  {{ doc.isValid ? 'Completed' : 'Incomplete' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


<!-- Delete Modal -->
<span id="openClientDeleteModal" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deletemodal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Delete Client</h5>
        <button type="button" class="btn-close" (click)="CancelDelete()" id="ClientListCancelDelete" aria-label="Close"></button>
      </div>
      <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveErr!=''" role="alert">
        <p>{{saveErr}}</p>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="saveErr=''" id="ClientListCancelDeleteicon"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="resetPass">
          <div class="row mb-3">
            <div class="col-lg-2">
              <label class="fw-bold mt-2">Password<sup class="text-danger" style="font-size: 1.35em;">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-5">
              <input type="password" class="form-control" formControlName="Password" [(ngModel)]="deleteList.admin_Password" (keyup)="passvalid($event)">
              <div *ngIf="resetPass.controls['Password'].invalid && (resetPass.controls['Password'].dirty || resetPass.controls['Password'].touched)" 
                class="alert alert-danger mt-2" style="height: 30px;">
                <div *ngIf="resetPass.controls['Password'].errors.required">
                  Password is required.
                </div>
              </div>
              <div *ngIf="passerror && resetPass.controls['Password'].valid" class="alert alert-danger mt-2">
                <div>
                  Enter Valid Password
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <label class="passwordnote mt-3"><i>Note: Password should contain at least 8 characters, including 1 special character, 1 lowercase, and 1 uppercase character.</i></label>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" [disabled]="!resetPass.valid || passerror || isClickButton" id="ClientListdeleteClient" (click)="deleteClient()">Delete</button>
        <button type="button" class="btn btn-secondary" (click)="CancelDelete()" id="ClientListdeleteClientbtn">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Error Delete Modal -->
<span id="openDeleteErrorModal" data-bs-target="#errordeletemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="errordeletemodal" data-bs-backdrop="static" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Unable to Delete</h5>
        <button type="button" class="btn-close" aria-label="Close" data-bs-dismiss="modal" id="ClientListnoteicon"></button>
      </div>
      <div class="modal-body">
        <div class="row ms-3">
          <div class="col-lg-12">
            <label class="text-danger">This Client has</label>
          </div>
        </div>
        <div class="row ms-5">
          <div class="col-lg-12 ms-5">
            <div *ngFor="let err of deleteError">
              <ul class="mb-0 ms-4">
                <li class="text-danger">{{err}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-sm" data-bs-dismiss="modal" id="ClientListnoteok">Ok</button>
      </div>
    </div>
  </div>
</div>
